<div class="modal-header">
  <h4 class="modal-title" translate>{{ options.titleKey }}</h4>
  <button class="btn-close" aria-label="Close" (click)="close()">

  </button>
</div>

<div class="modal-body">
  @if (!!options.messageKey) {
    <p class="translated-paragraph" translate>{{ options.messageKey }}</p>
  }

  <p class="translated-paragraph" translate>{{ defaultMessageKey }}</p>

  @if (!!options.infoKey) {
    <p class="translated-paragraph" translate>{{ options.infoKey }}</p>
  }

  @if (!!options.infoList && options.infoList.length > 0) {
    <ul class="info-list-scroll">
      @for (info of options.infoList; track info) {
        <li class="mb-2">{{ info }}</li>
      }
    </ul>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="no()" translate>
    {{ options.noKey }}
  </button>
  <button type="button" class="btn btn-primary" (click)="yes()" translate>
    {{ options.yesKey }}
  </button>
</div>
